export const SmileyNaice = ({ size = 48, color = "currentColor", ...restProps }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <title>SmileyNaice</title>
      <path
        d="M32 26H28C28 27.0609 27.5786 28.0783 26.8284 28.8284C26.0783 29.5786 25.0609 30 24 30C22.9391 30 21.9217 29.5786 21.1716 28.8284C20.4214 28.0783 20 27.0609 20 26H16C16 28.1217 16.8429 30.1566 18.3431 31.6569C19.8434 33.1571 21.8783 34 24 34C26.1217 34 28.1566 33.1571 29.6569 31.6569C31.1571 30.1566 32 28.1217 32 26ZM20 20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22C17.4696 22 16.9609 21.7893 16.5858 21.4142C16.2107 21.0391 16 20.5304 16 20C16 19.4696 16.2107 18.9609 16.5858 18.5858C16.9609 18.2107 17.4696 18 18 18C18.5304 18 19.0391 18.2107 19.4142 18.5858C19.7893 18.9609 20 19.4696 20 20ZM30 22C30.5304 22 31.0391 21.7893 31.4142 21.4142C31.7893 21.0391 32 20.5304 32 20C32 19.4696 31.7893 18.9609 31.4142 18.5858C31.0391 18.2107 30.5304 18 30 18C29.4696 18 28.9609 18.2107 28.5858 18.5858C28.2107 18.9609 28 19.4696 28 20C28 20.5304 28.2107 21.0391 28.5858 21.4142C28.9609 21.7893 29.4696 22 30 22Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44 24C44 35.046 35.046 44 24 44C12.954 44 4 35.046 4 24C4 12.954 12.954 4 24 4C35.046 4 44 12.954 44 24ZM40 24C40 28.2435 38.3143 32.3131 35.3137 35.3137C32.3131 38.3143 28.2435 40 24 40C19.7565 40 15.6869 38.3143 12.6863 35.3137C9.68571 32.3131 8 28.2435 8 24C8 19.7565 9.68571 15.6869 12.6863 12.6863C15.6869 9.68571 19.7565 8 24 8C28.2435 8 32.3131 9.68571 35.3137 12.6863C38.3143 15.6869 40 19.7565 40 24Z"
        fill={color}
      />
    </svg>
  );
};
